import { lock } from "assets/icons";
import { CustomModal } from "components/modals/ModalBox";
import React from "react";

const ResetSuccess = ({ show, setSteps, close }) => {
  // -------go-to-home-page-----------
  const navigateLoginPage = () => {
    setSteps(1);
  };
  return (
    <CustomModal
      show={show}
      handleClose={close}
      className={"logout reset_password_modal"}
      cancelText="Cancel"
      confirmText="Logout"
    >
      <div className="logout_content">
        {/* <span className="icon"> */}
        <img src={lock} alt="" />
        {/* </span> */}
        <h5>Password Changed Successfully!.</h5>
        <p>
          Your password has been reset successfully. Kindly login with your new
          login credentials.
        </p>

        <div className={`button_wrap`}>
          <button type="button" className="button" onClick={navigateLoginPage}>
            Go to Login
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default ResetSuccess;
